import {getPersonAdapter, IPersonAdapter, ITokenResponse, IVendorData} from "../adapters/PersonAdapter";

interface LivenessSessionData {
    data: {
        vendor: string;
        liveness_session: string;
        person_uuid: string;
        vendor_data: IVendorData;
        trace_id?: string;
    };
}

interface IAuthenticationUseCase {
    personsVerificationChallenge: (vendor: string, livenessSessionId: string, vendorData: IVendorData) => Promise<ITokenResponse>;
    deviceVerificationChallenge: (personUuid: string, deviceId: string, livenessSessionId: string) => Promise<ITokenResponse | null>;
    fetchLivenessSession: (livenessSessionId: string) => Promise<LivenessSessionData>;
}

class AuthenticationUseCase implements IAuthenticationUseCase {
    constructor(private personAdapter: IPersonAdapter) {}
    deviceVerificationChallenge(personUuid: string, deviceId: string, livenessSessionId: string): Promise<ITokenResponse | null> {
        return this.personAdapter.fetchTokenByDevice(personUuid, deviceId, livenessSessionId);
    }
    personsVerificationChallenge(vendor: string, livenessSessionId: string, vendorData: IVendorData): Promise<ITokenResponse> {
        return this.personAdapter.fetchToken(vendor, livenessSessionId, vendorData);
    }
    fetchLivenessSession(livenessSessionId: string): Promise<LivenessSessionData> {
        return this.personAdapter.fetchLivenessSession(livenessSessionId) as Promise<LivenessSessionData>;
    }
}

const authenticationUseCase = new AuthenticationUseCase(getPersonAdapter());
export { authenticationUseCase, AuthenticationUseCase };
export type { IAuthenticationUseCase };
